import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Spinner,
  useTimeout,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { requestServerApi, serverApi } from '../../../../../api/api';
import ModalHeaderComponent from '../../../../../components/ModalHeader';
import SelfStudyRecords from './SelfStudyRecords';

type Props = {
  onClose: (name: string, response: any) => void;
};
export default function SelfStudyHistoryModal({ onClose }: Props) {
  const company_id: string = useParams<any>().companyId;
  const learner_id: string = useParams<any>().learnerId;
  const [selfStudyRecords, setSelfStudyRecords] = useState<any[]>([]);
  const [fetchCompleted, setFetchCompleted] = useState(false);

  const closeModal = () => {
    onClose('selfStudyHistoryModal', '');
  };

  const getRecords = () => {
    // NOTE 学習記録を１APIで取得しているため、ここで取得するのが一番効率がいい（ただし分けたほうが負荷が少なくなると思う）
    const apiResponse = requestServerApi<any>(() =>
      serverApi.organizationsControllerGetLearnerStudyRecords(company_id, learner_id),
    );
    apiResponse.then((data) => {
      setSelfStudyRecords(data.data.data[0]?.drillRecords);
      setFetchCompleted(true);
    });
  };
  useTimeout(() => {
    // useEffectで開いたと同時に処理を初めると若干重くなるため、少しずらす
    getRecords();
  }, 100);

  return (
    <>
      <Modal isOpen={true} onClose={closeModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeaderComponent title="自習" />

          <ModalBody>
            <Flex overflowY="auto" height="500px" direction={'column'}>
              {fetchCompleted ? (
                <SelfStudyRecords selfStudyRecords={selfStudyRecords} />
              ) : (
                <Box marginX="auto" marginY="10">
                  <Spinner color="teal" />
                </Box>
              )}
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
